function changeTabs(e) {
  e.preventDefault();
  var target = e.target;
  var tablist = target.closest('[role="tablist"]');
  var container = target.closest('[data-tab-container]');
  var tabpanels = container.querySelector('.tab-content');
  var activeClass = 'active';

  // Remove all current selected tabs
  tablist.querySelectorAll('[aria-selected="true"]').forEach(function (tab) {
    tab.setAttribute('aria-selected', false);
    tab.classList.remove(activeClass);
  });

  // Set this tab as selected
  target.setAttribute('aria-selected', true);
  target.classList.add(activeClass);

  // Hide all tab panels
  for (var i = 0; i < tabpanels.children.length; i++) {
    tabpanels.children[i].setAttribute('hidden', true);
    tabpanels.children[i].classList.remove(activeClass);
  }

  // Show the selected panel
  var activeTab = container.parentNode.querySelector(
    '#' + target.getAttribute('aria-controls')
  );
  activeTab.removeAttribute('hidden');
  activeTab.classList.add(activeClass);

  var selectTabEvent = new CustomEvent('performance.selectContent', {
    detail: {
      content_type: 'Nutrition facts tab',
      content_id: target.innerText
    }
  });
  window.dispatchEvent(selectTabEvent);
}

document.addEventListener('DOMContentLoaded', function () {
  var tabs = document.querySelectorAll('[data-tab-container] [role="tab"]');

  // Add a click event handler to each tab
  tabs.forEach(function (tab) {
    tab.addEventListener('click', changeTabs);
  });

  function openNutritionDetails() {
    var hash = location.hash.substring(1);
    if (hash) {
      var details_group = document.getElementById(hash);
    }
    if (details_group && details_group.id === 'nutrition-details') {
      var details = details_group.querySelectorAll('details.nutrition-details');
      if (details) {
        details.forEach(function (detail) {
          detail.open = true;
        });
      }
    }
  }

  var tabContainers = document.querySelectorAll('[data-tab-container]');
  if (tabContainers) {
    tabContainers.forEach(function (tabContainer) {
      var tabbed_nutrition_details = tabContainer.querySelectorAll(
        'details.nutrition-details'
      );
      if (tabbed_nutrition_details) {
        tabbed_nutrition_details.forEach(function (nutrition_detail) {
          var _this = nutrition_detail;
          var summary = nutrition_detail.querySelector('summary');

          summary.addEventListener('click', function (event) {
            tabbed_nutrition_details.forEach(function (nutrition_detail) {
              if (_this != nutrition_detail) {
                if (summary.parentElement.open == false) {
                  nutrition_detail.open = true;
                } else {
                  nutrition_detail.open = false;
                }
              }
            });
          });
        });
      }
    });
  }

  var links = document.querySelectorAll('[href="#nutrition-details"]');
  if (links) {
    links.forEach(function (link) {
      link.addEventListener('click', openNutritionDetails);
    });
  }
  window.addEventListener('hashchange', openNutritionDetails);
  openNutritionDetails();
});
